import { MS_IN_SEC } from './const';
import { normalizeTimestamp } from './normalize-timestamp';

/**
 * Преобразует timestamp из миллисекунд в секунды.

 * @example
 * toUnixTimestamp(1699958377000) → 1699958377
 */
export function toUnixTimestamp(data: Date | number) {
  if (data instanceof Date) {
    return Math.floor(data.getTime() / MS_IN_SEC);
  }

  const normalized = normalizeTimestamp(data);

  return Math.floor(normalized / MS_IN_SEC);
}
